/**
 * simple event listener for click events on category link
 */
module.exports = (function () {
  'use strict';

  var init = function () {

    var btt = document.getElementById("footer-btt");
    if (btt === null || btt.length === 0) {return;}

    btt.addEventListener("click", function(event){
      scrollTo(0, 500);
    });

  };

  return {
    init: init
  };

}());

